/**
 * A one-time secret in a dialog, with a control to hide it. It opens shown so
 * it can be copied once; hidden, it reads as dots. The value is never logged.
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const MASK_LENGTH = 24;

/** Dots instead of the value; the length says nothing about the secret. */
export const maskSecret = (value: string): string =>
  value ? '•'.repeat(MASK_LENGTH) : '';

const SecretValue: React.FC<{ value: string; className?: string }> = ({
  value,
  className,
}) => {
  const { t } = useTranslation();
  const [hidden, setHidden] = useState(false);

  return (
    <div className='teamSecret'>
      <div className={className} data-testid='team-secret-value'>
        {hidden ? maskSecret(value) : value}
      </div>
      <button
        type='button'
        className='teamSecret__toggle'
        aria-pressed={hidden}
        onClick={() => setHidden((h) => !h)}
      >
        {hidden ? t('Show') : t('Hide')}
      </button>
    </div>
  );
};

export default SecretValue;
